import React from 'react';

export default function PetOrbitLogo({ className = "w-10 h-10", iconOnly = false }) {
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <div className="relative shrink-0">
        {/* Orbital Ring */}
        <svg viewBox="0 0 100 100" className="w-full h-full drop-shadow-md">
          <circle 
            cx="50" cy="50" r="45" 
            fill="none" 
            stroke="url(#orbitGradient)" 
            strokeWidth="8" 
            strokeDasharray="210 70"
            className="animate-[spin_8s_linear_infinite]"
          />
          <defs>
            <linearGradient id="orbitGradient" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#0047AB" />
              <stop offset="100%" stopColor="#FF7F50" />
            </linearGradient>
          </defs>
          {/* Paw Print Mark */}
          <path 
            d="M50 35c-5 0-9 4-9 9 0 3 2 6 5 8v4c0 2 2 4 4 4s4-2 4-4v-4c3-2 5-5 5-8 0-5-4-9-9-9zm-15 15c-3 0-6 3-6 6 0 2 1 4 3 5l2 4c1 2 3 3 5 3s4-1 5-3l2-4c2-1 3-3 3-5 0-3-3-6-6-6zm30 0c-3 0-6 3-6 6 0 2 1 4 3 5l2 4c1 2 3 3 5 3s4-1 5-3l2-4c2-1 3-3 3-5 0-3-3-6-6-6z" 
            fill="#0047AB" 
          />
        </svg>
      </div>
      {!iconOnly && (
        <span className="text-2xl font-black bg-clip-text text-transparent bg-gradient-to-r from-[#0047AB] to-[#1E3A8A] tracking-tighter">
          Pet<span className="text-[#FF7F50]">Orbit</span>
        </span>
      )}
    </div>
  );
}